/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import LogoBlackSrc from 'components/ChoreoSystem/Images/Various/logos/WSO2_Integration_Platform_Black.svg';

export interface LogoConfig {
  src: string;
  alt: string;
  // Can add a default width, if needed this can be overridden when used
  width?: number;
}

export const logoBlack: LogoConfig = {
  src: LogoBlackSrc,
  alt: 'WSO2 Integration Platform Logo',
  width: 200, // 200 equivalent to theme.spacing(25)
};
